export default __webpack_public_path__ + "static/barfplan-blog-promo-small@2x-01fe9e3526573f03a3f6ee2248779f86.webp";